// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ThemeWrapper_wrapper__PvQdp"};